/**
 * 专注完成的系统通知：仅在 Android 原生环境生效，网页端静默跳过。
 * 计时开始时按 deadline 预约通知，即使应用退到后台也能准时提醒。
 */
import { isNativePlatform } from '@/platform/platform'

const FOCUS_NOTIFICATION_ID = 2601

async function getPlugin() {
  const { LocalNotifications } = await import('@capacitor/local-notifications')
  return LocalNotifications
}

export async function scheduleFocusDoneNotification(subject: string, deadlineMs: number) {
  if (!isNativePlatform()) return
  try {
    const plugin = await getPlugin()
    let permission = await plugin.checkPermissions()
    if (permission.display !== 'granted') {
      permission = await plugin.requestPermissions()
      if (permission.display !== 'granted') return
    }
    await plugin.schedule({
      notifications: [{
        id: FOCUS_NOTIFICATION_ID,
        title: '专注完成 🎉',
        body: `${subject} 已完成`,
        schedule: { at: new Date(deadlineMs), allowWhileIdle: true },
      }],
    })
  } catch (error) {
    console.warn('通知预约失败', error)
  }
}

export async function cancelFocusDoneNotification() {
  if (!isNativePlatform()) return
  try {
    const plugin = await getPlugin()
    await plugin.cancel({ notifications: [{ id: FOCUS_NOTIFICATION_ID }] })
  } catch (error) {
    console.warn('通知取消失败', error)
  }
}
